import { Capacitor, registerPlugin } from '@capacitor/core';
import { isNativeShell } from '../auth/authRedirect';

const LineMedicIap = registerPlugin('LineMedicIap');

export function nativeIapAvailable() {
  return isNativeShell() && Capacitor.getPlatform() === 'ios';
}

export async function browseForIap(sourceUrl) {
  if (!nativeIapAvailable()) return null;
  const result = await LineMedicIap.browse({ url: String(sourceUrl || '').trim() });
  return String(result?.url || '').trim();
}

export async function consumePendingIapSelection() {
  if (!nativeIapAvailable()) return null;
  const result = await LineMedicIap.consumePendingSelection();
  const url = String(result?.url || '').trim();
  if (!url) return null;
  return {
    url,
    sourceUrl: String(result?.sourceUrl || '').trim(),
  };
}

export async function clearPendingIapSelection() {
  if (!nativeIapAvailable()) return;
  await LineMedicIap.clearPendingSelection();
}

export async function downloadNativeIap(documentUrl) {
  if (!nativeIapAvailable()) return null;
  const result = await LineMedicIap.download({ url: String(documentUrl || '').trim() });
  return {
    id: String(result?.id || ''),
    fileUri: String(result?.fileUri || ''),
    filename: String(result?.filename || 'Incident-IAP.pdf'),
    originalUrl: String(result?.originalUrl || documentUrl || ''),
    bytes: Number(result?.bytes || 0),
    pageCount: Number(result?.pageCount || 0),
    textPages: Array.isArray(result?.textPages) ? result.textPages.map(value => String(value || '')) : [],
    textTruncated: Boolean(result?.textTruncated),
  };
}

export async function resolveNativeIapFile(id, fallbackFileUri = '') {
  if (!nativeIapAvailable() || !id) return String(fallbackFileUri || '');
  const result = await LineMedicIap.resolve({ id: String(id) });
  return String(result?.fileUri || fallbackFileUri || '');
}

export async function deleteNativeIap(id) {
  if (!nativeIapAvailable() || !id) return false;
  await LineMedicIap.delete({ id: String(id) });
  return true;
}

export function localIapWebUrl(fileUri) {
  if (!fileUri) return '';
  return Capacitor.convertFileSrc(String(fileUri));
}
